import KeyboardNavigation from '../../grid/keyboardNavigation';
import ExpandButtons from '../../extensions/expandButtons';
import InlineEditors from '../../controllers/inlineEditors';

export default instance => {
  instance.attachEvent('onGanttRender', () => KeyboardNavigation.onGanttRender());
  instance.attachEvent('onGanttRender', () => {
    if (instance.ganttDataApi.isBase()) {
      ExpandButtons.debouncedUpdatePositions();
    }
  });
  instance.attachEvent('onGanttRender', () => {
    if (InlineEditors.isActive()) {
      InlineEditors.onGanttRender();
    }
  });
  instance.attachEvent('onGanttRender', () => setTimeout(() => {
    instance.callEvent('onUpdateWindowParams');
  }));
};
